/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useEffect, useState } from "react";
import { Col, Row } from "components/Grid";
import { FieldArray, Formik } from "formik";
import Icon from "components/Icon";
import Colors from "constants/Colors";
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import { ActionContainer, InlineLabel, Line, ListContent } from "./styles";
import { Label, ModalConfirmDelete } from '@fitinsur/components';
import Checkbox from 'components/Form/CheckBox';
import { FileIcon, defaultStyles } from 'react-file-icon';
import moment from 'moment';

const fitinsur = new FitinsurAPI();


const ListDetail = ({
  hasDelete,
  listDocuments,
  document,
  idOperation,
  columns,
  isClient,
  nameArray,
  handleSelectDocument,
  selectedDocs,
  selectAllDocs,
  permissions,
  onHistoryClick,
  hiddenTrash,
  history,
  expired
}) => {
  const authContext = useContext(GlobalAuthContext);
  const loading = useContext(GlobalLoaderContext);
  const mc = new MessageCenter();
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [url, setUrl] = useState(null);

  fitinsur.setAuthToken(authContext.token);

  function handleRmvAttach(idOperation, idDocument) {
    loading.start();

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestWordingDelAttach(idOperation, idDocument)
      .then(data => data.json())
      .then(resp => {
        if (resp.ret_code !== 200) {
          mc.error(resp.ret_msg_details);
          loading.stop();
          return;
        } else {
          listDocuments();
        }
      }).catch(err => {
        mc.error("An error happened, please try again: " + err);
        loading.stop();
      });
  };

  const renderFlowClient = () => {
    if (nameArray === 'supportDocuments') return (
      <Icon
        disabled={!hasDelete}
        onClick={() => hasDelete && handleRmvAttach(idOperation, document.idDocument)}
        name="trash"
        style={!hasDelete ? opacity : null}
      />
    )
  }

  // useEffect(() => {
  //   if(document.documentName){
  //     const simpleUrl = document.url.split('?');
  //     const queryUrl = simpleUrl[0] + '/'+ document.documentName +'?'+ simpleUrl[1] ;
  //     setUrl(queryUrl)
  //   }else{
  //     setUrl(document.url)
  //   }
  // }, [document])

  const newFileExtension = document.documentName.split('.').pop();
  const file = newFileExtension.length > 5 ? 'pdf' : newFileExtension;

  let fileExtension = document.documentTypeExtension || document.nameDocumentExtension || file;

  return (
    <>
      <Formik>
        <FieldArray name="listDetail" render={() =>
          <span style={{ width: '100%' }}>
            <Row style={{ justifyContent: 'space-between' }}>
              <Col md={columns[0].col} className="pl-0">
                <InlineLabel>
                  {columns[0].title}
                </InlineLabel>
                <Label textColor={Colors.GRAY[0]} wordBreak>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {!history && expired ? null : (
                      <Checkbox
                        checked={selectedDocs.includes(document.idDocument)}
                        onChange={() => handleSelectDocument(document.idDocument, nameArray)}
                      />)
                    }

                    <div style={{ width: '25px', minWidth: '25px', maxWidth: '25px', marginRight: '10px' }}>
                      <FileIcon extension={fileExtension} {...defaultStyles[fileExtension]} />
                    </div>
                    {document.documentName}
                  </div>
                </Label>
              </Col>
              <Col md={columns[1].col} className="pl-0">
                <InlineLabel>
                  {columns[1].title}
                </InlineLabel>
                <Label textColor={Colors.GRAY[0]}>
                  {document.version}
                </Label>
              </Col>
              <Col md={columns[2].col} className="pl-0">
                <InlineLabel>
                  {columns[2].title}
                </InlineLabel>
                <Label textColor={Colors.GRAY[0]}>
                  {document.documentType}
                </Label>
              </Col>
              <Col md={columns[3].col} className="pl-0">
                <InlineLabel>
                  {columns[3].title}
                </InlineLabel>
                <Label textColor={Colors.GRAY[0]}>
                  {document.uploadedBy}
                </Label>
              </Col>
              <Col md={columns[4].col} className="pl-0">
                <InlineLabel>
                  {columns[4].title}
                </InlineLabel>
                <Label textColor={Colors.GRAY[0]}>
                  {moment(document.uploadedDate).format("DD/MM/YYYY")}
                </Label>
              </Col>
              <Col md={columns[5].col} className="px-0">
                <ActionContainer>
                  <Icon
                    onClick={() => window.open(document.url, '_blank')}
                    name="search-gray"
                  />
                  {onHistoryClick && (
                    <Icon
                      onClick={() => onHistoryClick(document)}
                      name="history"
                      style={icon}
                    />
                  )}
                  {!isClient ?
                    !hiddenTrash && (
                      <Icon
                        disabled={!hasDelete || !permissions.DOCUMENT_GENERAL}
                        onClick={() => hasDelete && setShowDeleteConfirmation(true)}
                        name="trash"
                        style={!hasDelete ? opacity : null}
                      />
                    )
                    : renderFlowClient()}
                </ActionContainer>
              </Col>
            </Row>
            <Row>
              <Col className="pl-2 pr-2">
                <Line />
              </Col>
            </Row>
          </span>
        }
        />
      </Formik>

      <ModalConfirmDelete
        show={showDeleteConfirmation}
        onModalClose={() => setShowDeleteConfirmation(false)}
        onConfirm={() => handleRmvAttach(idOperation, document.idDocument)}
      />

    </>

  );
};

const spaceLabel = {
  allignItens: "center",
};

const icon = {
  color: Colors.GRAY[6],
};

const opacity = {
  color: Colors.GRAY[5],
  opacity: 0.5,
  cursor: "not-allowed",
};

const opacityAllowed = {
  color: Colors.GRAY[5],
  opacity: 0.5,
};

export default ListDetail;
